<template>
  <div class="text-center">
    <div v-if="appointmentCount" v-tooltip="tooltipConfig" class="appointment-count">
      {{ appointmentCount }}
    </div>
  </div>
</template>

<script>
export default {
  props: ["data", "monthData"],

  data() {
    return {};
  },

  computed: {
    appointments() {
      if (this.data.type !== "current-month") {
        return [];
      }

      if (!this.monthData || !this.data || !this.data.day) {
        return [];
      }
      const day = this.data.day.split("-");
      if (!day || !day[2]) {
        return [];
      }

      const dayIndex = parseInt(day[2]) - 1;
      if (!this.monthData[dayIndex]) {
        return [];
      }

      const appointments = this.monthData[dayIndex].appointments;

      if (!appointments || appointments.length === 0) {
        return [];
      }

      return appointments;
    },

    appointmentCount() {
      if (!this.appointments) {
        return null;
      }

      return this.appointments.length;
    },

    tooltipContent() {
      if (!this.appointments || this.appointments.length === 0) {
        return null;
      }

      const content = this.appointments
        .map(
          (appointment) =>
            `<tr><td class="pr-2">#J${appointment.job_id}</td><td class="pr-2"><b>${appointment.job.job_address.city}</b></td><td>${appointment.job.status}</td></tr>`
        )
        .join("");

      return `<table>${content}</table>`;
    },

    tooltipConfig() {
      return {
        content: this.tooltipContent,
        classes: ["cell-alt-small-tooltip-theme"],
        placement: "bottom-start",
        html: true,
      };
    },
  },
};
</script>
